import React from "react";
import "./Footer.css";
import Logo, { LogoType } from "../Logo/Logo";
import { Link } from "react-router-dom";
import { TranslationsMap } from "../../pages/CountryPage/CountryPage";
import packageJson from "../../../package.json";

interface FooterProps {
  translations: TranslationsMap;
}

const Footer: React.FC<FooterProps> = ({ translations }) => {
  return (
    <footer className="footer mt-16">
      <Logo type={LogoType.Grey} />
      <div className="link-wrapper">
        <p className="gray-text">DHDK_CORABC1.1_001</p>
        <p className="gray-text">Version {packageJson.version}</p>
        <Link to={window.location.pathname + "/privacy-policy"}>
          <p className="clickable">
            {translations["landingPage.footer.privacyPolicy"]}
          </p>
        </Link>
        <a href="/licenses.txt">
          <p className="clickable">
            {translations["landingPage.footer.licenses"]}
          </p>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
